import Box from '@mui/material/Box';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import style from '../../common-style/common-style.module.css';
import IconButton from '@mui/material/IconButton';
import { Fragment } from 'react';
import { getLocalStoreItem, setLocalStoreItem } from '../../../../helpers/localStoreHandler';

const labelText = (tooltip, label) => tooltip ? (
  <Tooltip 
    arrow 
    title={
      <Fragment>
        {tooltip === 'insightScore' && (
          <div className={style.tooltipBreak}>
            <span>Evaluates the alignment of this output with review data, tone, and brand safety, based on relevance and sentiment scores. Higher scores indicate better alignment with customer feedback and brand guidelines.</span>
            <span><u>Sentiment Score</u>: A Number showing positive, neutral or negative user sentiment in user feedback overall. Higher is more positive sentiment. and lower more negative.</span>
            <span><u>Relevance score</u>: How well this content matches what customers ask and what reviews mention. Higher is better - more on-topic and useful content.</span>
          </div>
        )}
        {tooltip === 'bsci' && (
          <div className={style.tooltipBreak}>
            <span>Determines overall safety & quality rating for this content, measures relevance, tone, usefulness and risk. The index takes a value between 0-1, a higher score indicates lower risk and more alignment with brand standards and safer to publish.</span>
          </div>
        )}
        {tooltip === 'reviewsStats' && (
          <div className={style.tooltipBreak}>
            <span><u>REC</u>: Review Count</span>
            <span><u>AVR</u>: Average Rating</span>
            <span><u>RAC</u>: Rating Count</span>
          </div>
        )}
      </Fragment>
    }
  >
    <span>
      {label}
      <HelpOutlineIcon 
        sx={{
          cursor: 'pointer', 
          width: '.9rem', 
          height: '.9rem', 
          position: 'relative', 
          top:'2px', 
          right: '-2px'
        }} 
      />
    </span>
  </Tooltip>) : (label);

export default function BMPTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, collapseAll, onCollapseAll, isCheckCollapsible } = props;
  // const {pageNumber} = JSON.parse(getLocalStoreItem('bmp_pagination')); 
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const allCollapsible = () => {
    onCollapseAll(!collapseAll);
    const isLocal = getLocalStoreItem('pdpFaqChangesState');
    if (isLocal) {
      const parsedData = JSON.parse(isLocal);
      setLocalStoreItem('pdpFaqChangesState', JSON.stringify({...parsedData, mainCollapse: !collapseAll}));
    }
  }


  return (
    <TableHead>
      <TableRow
        sx={{
            backgroundColor: '#f7f7feff',
            ".MuiTableCell-root": {
                fontWeight: 700,
                lineHeight: 1.2,
                fontSize:'1rem',
                color:'#1f36c8',
                "& :hover": {
                  color:'#1f36c8'
                },
                "& :focus": {
                  color:'#1f36c8'
                },
            },
            "th": {
              "&:hover": {
                ".MuiTableSortLabel-icon": {
                  opacity: '1 !important',
                }
              },
              ".MuiTableSortLabel-icon": {
                marginRight:'-8px',
                marginLeft:0,
                opacity:'.5 !important',
              },
              ".MuiButtonBase-root.Mui-active": {
                color: 'inherit',
                ".MuiTableSortLabel-icon": {
                  color: 'inherit'
                }
              }
            }
        }}
      >
        <TableCell sx={{minWidth: 40, padding:0}}>
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'Select all',
            }}
          />
          {isCheckCollapsible && (
            <Tooltip title={collapseAll ? 'Collapse All' : 'Expand All'}>
              <IconButton 
                aria-label='Expand All row'
                aria-expanded={collapseAll ? "true" : "false"}
                onClick={allCollapsible}
                sx={{width: '28px', height: '28px', marginLeft: '-7px', marginTop: '-1px', marginRight: '-5px'}}
              >
                <KeyboardArrowRightIcon 
                    fontSize="1rem"
                    sx={{transform: collapseAll ? 'rotate(90deg)' : 'rotate(0)', transition: 'transform 0.2s ease-in-out'}}
                />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>
        {props.headCells.map((headCell) => {
          
          return (
            <TableCell
              key={headCell.id}
              align={headCell.left ? 'left' : 'center'} 
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{minWidth: headCell.minWidth }}
              className={style[headCell.className]}
            >
              {headCell.enableSort ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id, headCell.disableSort)}
                >
                  {labelText(headCell.tooltip, headCell.label)}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                  labelText(headCell.tooltip, headCell.label)
              )}
            </TableCell>  
          )
          })}
      </TableRow>
    </TableHead>
  );
}